<template>
  <fieldset>
    <label class="form-group">
      Штрихкод
      <label v-if="actionsAreVisible" class="field__label_required">
        *
      </label>
    </label>
    <div class="content">
      <div v-show="savedBarcode" class="form-group">
        <canvas ref="barcode" />
      </div>
      <div v-if="savedBarcode" class="form-group">
        <span>Отсутствует</span>
      </div>
      <button
        v-if="actionsAreVisible"
        type="button"
        class="content__button_generator"
        @click="modalIsVisible = true"
      >
        {{ buttonLabel }}
      </button>
    </div>
    <BarcodeModal
      v-if="modalIsVisible"
      :init-value="savedBarcode"
      @close="closeModal"
    />
  </fieldset>
</template>

<script>
// Возможность сбросить значение до дефолтного
import BarcodeModal from '@/_shared/components/modals/BarcodeModal';
import { configs } from '@/_shared/constants/configs';
export default {
  components: {
    BarcodeModal,
  },
  props: {
    initValue: {
      type: String,
      default: null,
    },
    actionsAreVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      savedBarcode: this.initValue,
      modalIsVisible: false,
    };
  },
  computed: {
    buttonLabel() {
      return !!this.savedBarcode ? 'Изменить' : 'Сгенерировать';
    },
  },
  methods: {
    closeModal(barcode) {
      this.savedBarcode = barcode;
      this.modalIsVisible = false;
      this.renderBarcode();
      this.$emit('on-save', barcode);
    },
    renderBarcode() {
      const config = configs.jsBarcode;
      JsBarcode(this.$refs.barcode)
        .options(config.general)
        .EAN13(this.savedBarcode, config.barcode)
        .blank(config.blankSize)
        .render();
    },
  },
};
</script>

<style scoped>
.content__button_generator {
  position: relative;
  border-radius: 4px;
  border: #337ab7 2px solid;
  box-shadow: 0 4px 7px rgba(0, 0, 0, 0.4);
  display: inline-flex;
  background-color: transparent;
  align-items: center;
  justify-content: center;
  color: #337ab7;
  font-weight: bold;
  padding: 0.5em 0.5em;
  text-align: center;
  cursor: pointer;
}
.content__button_generator:hover {
  transition: 0.2s;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/_shared/features/form/BarcodeGenerator.vue